import React from "react";
import "./style.css";

export const CourseLandingHeaderInfo = ({ course_type="", language, course_title, course_teacher_name }) => {

  const translations = {
    "en": {
      "with": "with",
      "view_trailer": "WATCH TRAILER",
    },
    "es": {
      "with": "con",
      "view_trailer": "VER TRAILER",
    },
    "pt": {
      "with": "com",
      "view_trailer": "VEJA O TRAILER",
    },
    "fr": {
      "with": "avec",
      "view_trailer": "REGARDE TRAILER",
    }
  };

  const getTrans = (text) => {

    return translations[language][text];

  }

  const playFSVideo = () => {

    if ( document.getElementById('reveal_block_div') )
      document.getElementById('reveal_block_div').style.display = "none";

    if (document.getElementById('inside_loop_video_wrapper'))
      document.getElementById('inside_loop_video_wrapper').classList.remove('d-none');

    if (document.getElementById('inside_loop_video'))
      document.getElementById('inside_loop_video').classList.remove('d-none');

    if ( document.getElementsByClassName('landing_loop_div')[0] )
      document.getElementsByClassName('landing_loop_div')[0].style.opacity = 1;


    const elem = document.getElementById("inside_loop_video");

    elem.oncanplaythrough = function () {
      console.info("Can play through");
      elem.play();
      if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    }

    elem.load();


    //setTimeout( () => {

      //const elem = document.getElementById("inside_loop_video");

      //elem.currentTime = 0;
      //elem.play();

      /*
      if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
      */

    //}, 1000);

  };


  return (
    <div className="course_landing_header_div">

      <div className="notranslate course_type_title">{course_type}:</div>

      <div className="notranslate course_title text-uppercase" dangerouslySetInnerHTML={{__html: course_title}}></div>

      <div className="course_title_horizontal_line"></div>

      <div className="notranslate course_teacher_name text-capitalize">{getTrans("with")} {course_teacher_name}</div>

      <div onClick={playFSVideo} className="cursor-pointer view_trailer_button"><svg width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_669_5794)">
          <path d="M0.708781 0C0.991278 0.0658445 1.22017 0.242899 1.46507 0.38418C2.83513 1.17561 4.2029 1.97145 5.57041 2.7678C5.65298 2.81602 5.73503 2.87124 5.80286 2.93838C6.06605 3.19916 6.06504 3.57401 5.80235 3.83609C5.74088 3.89753 5.66873 3.95015 5.59506 3.9963C4.06825 4.95156 2.54044 5.90553 1.01262 6.85976C0.860954 6.95463 0.69989 7.01944 0.518503 6.99456C0.245406 6.95723 0.0477602 6.74414 0.0127022 6.45458C0.00482683 6.38925 0.000508087 6.32289 0.000508087 6.25705C0 4.41651 0.000254044 2.57571 0 0.734918C0 0.610747 0.0139724 0.489427 0.0650351 0.375106C0.151918 0.179906 0.295453 0.0549569 0.503768 0.0116654C0.514438 0.0093323 0.524346 0.00388846 0.534762 0C0.592938 0 0.65086 0 0.709036 0H0.708781ZM0.624185 0.593897C0.617834 0.5996 0.611229 0.605562 0.604878 0.611265V6.40092C2.21475 5.39536 3.81065 4.39862 5.40655 3.40188C5.40579 3.39125 5.40478 3.38088 5.40401 3.37025C3.81091 2.4448 2.21755 1.51935 0.624185 0.593897Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_669_5794">
            <rect width="6" height="7" fill="white"/>
          </clipPath>
        </defs>
      </svg> <span className="view_trailer_button_text">{getTrans("view_trailer")}</span></div>

    </div>
  );

};
